<template>
  <div>
    <yxt-switch
      v-model="getValue"
      :active-value="0"
      :inactive-value="1"
      v-bind="$attrs.attrs"
      v-on="$attrs.on"
    ></yxt-switch>
    <span class="tlive-create__switch--text tlive-create__tip">
      {{ $t('pc_biz_seePlayback' /* 开启后，员工可以观看直播回放视频 */) }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'LiveRecorded',
  props: {
    value: {
      type: Number,
      default: 0
    }

  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="less"></style>
